import { OPPORTUNITY_STAGES } from '../../types/OpportunityStage';
import { SalesOpportunityTeamMember } from '../../services/salesOpportunitiesApi';
import { OpportunityBoardFilterState } from './opportunityBoardUtils';

type OpportunityBoardFiltersProps = {
  filters: OpportunityBoardFilterState;
  teamMembers: SalesOpportunityTeamMember[];
  onChange: (filters: OpportunityBoardFilterState) => void;
};

export function OpportunityBoardFilters({
  filters,
  teamMembers,
  onChange,
}: OpportunityBoardFiltersProps) {
  return (
    <div className="mb-4 flex flex-wrap items-end gap-3 rounded-2xl border border-secondary-200 bg-white p-4">
      <label className="flex min-w-[200px] flex-1 flex-col gap-1 text-sm">
        <span className="font-medium text-secondary-700">Buscar</span>
        <input
          type="search"
          className="erp-input"
          placeholder="Título, cliente, segmento..."
          value={filters.search}
          onChange={(event) => onChange({ ...filters, search: event.target.value })}
        />
      </label>

      <label className="flex min-w-[180px] flex-col gap-1 text-sm">
        <span className="font-medium text-secondary-700">Responsável</span>
        <select
          className="erp-input"
          value={filters.ownerUserId}
          onChange={(event) => onChange({ ...filters, ownerUserId: event.target.value })}
        >
          <option value="">Todos</option>
          {teamMembers.map((member) => (
            <option key={member.id} value={member.id}>
              {member.name}
            </option>
          ))}
        </select>
      </label>

      <label className="flex min-w-[160px] flex-col gap-1 text-sm">
        <span className="font-medium text-secondary-700">Estágio</span>
        <select
          className="erp-input"
          value={filters.stage}
          onChange={(event) => onChange({ ...filters, stage: event.target.value })}
        >
          <option value="">Todos</option>
          {OPPORTUNITY_STAGES.map((stage) => (
            <option key={stage.id} value={stage.id}>
              {stage.label}
            </option>
          ))}
        </select>
      </label>

      {(filters.search || filters.ownerUserId || filters.stage) && (
        <button
          type="button"
          className="erp-btn-secondary"
          onClick={() => onChange({ search: '', ownerUserId: '', stage: '' })}
        >
          Limpar filtros
        </button>
      )}
    </div>
  );
}
